import { OdataFilters, queryCollection, queryParams } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/organizationRecommendations";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, params);

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const getListForUser = () => request(`${resource}/getListForUser`, { method: "GET" });

const сheckOrganizationRecommendation = (params: {}) =>
    request(`${resource}/checkOrganizationRecommendation${queryParams(params)}`, { method: "GET" });

export { index, apply, delItem, getListForUser, сheckOrganizationRecommendation };
